import { render, staticRenderFns } from "./electrogilding_thickness.vue?vue&type=template&id=6454ae34&scoped=true"
import script from "./electrogilding_thickness.vue?vue&type=script&lang=js"
export * from "./electrogilding_thickness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454ae34",
  null
  
)

export default component.exports